var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"disabled":_vm.disabled,"placeholder":"เลือกสถานะ","clearable":""},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},_vm._l((_vm.statusList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }